import { Typography } from '@mui/material';
import get from 'lodash/get';
import { TextFieldProps, useRecordContext } from 'react-admin';
import { locale, numberFormatConfiguration } from './numberFormatConfiguration';

export type PriceFieldProps = TextFieldProps & {
  label?: string;
};

export const PriceField = (props: PriceFieldProps) => {
  const record = useRecordContext();

  const price = Intl.NumberFormat(locale, numberFormatConfiguration).format(
    record && props.source && get(record, props.source)
      ? get(record, props.source) / 100
      : 0
  );

  if(props.label){
    return <Typography {...props}>{`${props.label}: ${price}`}</Typography>;
  }

  return <Typography {...props}>{price}</Typography>;
};
